import { AdapterContext, BaseAsyncAdapter, ITridentResource } from 'shell-models-lib';
import { Model } from 'app/model/backendmodel';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { NamedArray } from 'app/model/base/namedarray';
import { Column } from 'app/model/dataset/column';
import { columnResourceToValue, columnValueToResource } from '../../column.adapter.util';
import { IStructure } from '../../datasets/dataset.constant.adapter';

export abstract class CopySinkAdapter<T, U> extends BaseAsyncAdapter<T, U> {
    public static getCommonCopySinkProperties(copySink: CopySink, copySinkType: string): Model.CopySink {
        return {
            type: copySinkType
        };
    }

    public static maxConcurrentConnectionsToResource(copySink: CopySink, resource: Model.CopySink): void {
        if (resource != null) {
            resource.maxConcurrentConnections = ValueAdapter.toResource(copySink, CopySink.MAXCONCURRENT_CONNECTIONS);
        }
    }

    public static maxConcurrentConnectionsToModel(resource: Model.CopySink, copySink: CopySink): void {
        if (copySink != null) {
            ValueAdapter.toModel(copySink, CopySink.MAXCONCURRENT_CONNECTIONS, resource.maxConcurrentConnections);
        }
    }

    public static toCommonCopySinkResource(
        copySink: CopySink,
        resource: Model.CopySink,
        context: AdapterContext
    ): void {
        //
    }

    public static toCommonCopySinkModel(copySink: CopySink, resource: Model.CopySink): void {
        //
    }

    public static columnValueToResource(
        copySink: CopySink,
        columns: NamedArray<Column>,
        context: AdapterContext
    ): IStructure[] | undefined {
        return columnValueToResource(copySink, columns, context);
    }

    public static columnResourceToValue(copySink: CopySink, columns: IStructure[] | undefined): NamedArray<Column> {
        return columnResourceToValue(copySink, columns);
    }

    protected async _toAzureResource(tridentResource: ITridentResource): Promise<U> {
        throw `Artifact type '${tridentResource.artifactType}' does not implement _toAzureResource method.`;
    }
}
